import { Grid, InputAdornment, TextField } from '@mui/material'
import React from 'react'

const Interval = ({ moduleValues, setModuleValues, item }) => (
  <Grid item xs={12} sm={6} lg={3}>
    <TextField
      size="small"
      fullWidth
      autoComplete='off'
      InputProps={{
        endAdornment: <InputAdornment position="end">ms</InputAdornment>,
      }}
      label={item}
      onChange={(e) =>
        setModuleValues((prev) => ({ ...prev, [item]: e.target.value }))
      }
      value={moduleValues?.[item] ?? ''}
      type='number'
    />
  </Grid>
)

export default Interval